export default __webpack_public_path__ + "static/media/Thajiwasglacier.176cf3ff.jpg";